import mensagens from '@/util/mensagens'
import util from '@/util'
import imageStream from '@/components/layout/imageStream/ImageStream.vue'
import defaultTable from '@/components/layout/defaultTable/DefaultTable.vue'
import constants from '@/util/constants'
import pagination from '@/components/layout/pagination/Pagination.vue'
import spinnerProcessando from '@/components/layout/spinnerProcessamento/SpinnerProcessamento.vue'

export default {
  name: 'usuarios',
  props: {
    idEmpresa: [Number, String],
    required: true
  },
  components: {
    imageStream,
    pagination,
    spinnerProcessando,
    'default-table': defaultTable
  },

  computed: {
  },

  data: () => {
    return {

      usuarios: [],
      fields: [
        { key: 'nome', sortable: true, label: 'Nome' },
        { key: 'email', sortable: true, label: 'Email' },
        {
          key: 'ativo',
          sortable: true,
          label: 'Ativo/Inativo',
          formatter: (value) => value === true ? constants.statusUsuario.ativoLabel : constants.statusUsuario.inativoLabel
        },
        {
          key: 'data_criacao',
          sortable: true,
          label: 'Data Cadastro',
          formatter: (value) => util.formatarData(value)
        }
      ],
      componenteOrdenacao: {
        campo: 'nome',
        sentido: 'asc'
      },
      componentePaginacao: {
        pagina: 1,
        registrosPorPagina: null,
        fonteDeDados: [],
        ultimaPagina: 1
      },
      filtrosPesquisa: [],
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        }
      }
    }
  },
  async mounted () {
    this.obterUsuariosEscritorio(this.idEmpresa)
  },

  methods: {
    async obterUsuariosEscritorio (id) {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      try {
        const parametrosRequisicao = {
          'page': this.componentePaginacao.pagina,
          'registrosPorPagina': this.componentePaginacao.registrosPorPagina,
          'filtros': this.filtrosPesquisa,
          'ordenacao': this.componenteOrdenacao
        }
        const resposta = await this.axios.post(`escritorios/${id}/usuarios/buscar`, parametrosRequisicao)
        const dados = resposta.data.retorno.dados
        this.usuarios = [...dados]
        this.componentePaginacao.fonteDeDados = resposta.data.retorno.paginacao
        this.componentePaginacao.ultimaPagina = resposta.data.retorno.paginacao.ultimaPagina
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },

    obterDadosPaginados (pagina, registrosPorPagina) {
      this.componentePaginacao.pagina = pagina
      this.componentePaginacao.registrosPorPagina = registrosPorPagina
      this.obterUsuariosEscritorio(this.idEmpresa)
    },

    ordenarLista (context) {
      if (!util.valorVazio(context.sortBy)) {
        this.componenteOrdenacao.campo = context.sortBy
        this.componenteOrdenacao.sentido = context.sortDesc === true ? 'desc' : 'asc'
        this.obterUsuariosEscritorio(this.idEmpresa)
      }
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    destacarUsuarioInativo (ativo) {
      if (!ativo) {
        return 'text-secondary'
      } else {
        return 'textos'
      }
    },
    tabelaSemRegistros (item, type) {
      if (util.valorVazio(item) && type === 'row-empty') {
        return 'text-center'
      }
    }
  }
}
